import ProjectLobbyView from 'Projects/views/ProjectLobbyView';

export default ProjectLobbyView;
